import Heading from "./Heading";

export default Heading("h5", "H5");
